import React from "react";
import useBatteryStatus from "../../hooks/useBatteryStatus";

// Battery gauge for the kiosk banner: a CSS-drawn shell whose fill tracks the
// charge, plus the percentage in text (readable across a room).
//
// Renders nothing when no battery source is available, so laptops and phones are
// unchanged — but that also makes "no indicator" indistinguishable from a bug on
// a locked-down tablet with no devtools. Load the board with ?bat=debug to make
// it report which source answered (or that none did) right in the banner.
export default function BatteryIndicator() {
  const battery = useBatteryStatus();
  const debug =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).get("bat") === "debug";

  if (!battery) {
    if (!debug) return null;
    const has = typeof navigator !== "undefined" && !!navigator.getBattery;
    const bridged = typeof window !== "undefined" && !!window.AndroidBattery;
    return (
      <span className="display-battery battery-debug">
        no battery source (getBattery:{has ? "y" : "n"} bridge:{bridged ? "y" : "n"})
      </span>
    );
  }

  const pct = Math.round(battery.level * 100);
  const level = pct <= 15 ? "critical" : pct <= 30 ? "low" : "ok";

  return (
    <span
      className={`display-battery battery-${level}`}
      title={battery.charging ? `Charging — ${pct}%` : `Battery ${pct}%`}
    >
      <span className="battery-shell">
        <span className="battery-fill" style={{ width: `${pct}%` }} />
      </span>
      <span className="battery-pct">
        {battery.charging && <span className="battery-bolt">⚡</span>}
        {pct}%
        {debug && <span className="battery-debug"> [{battery.source}]</span>}
      </span>
    </span>
  );
}
